export class ApiValidationError extends Error {
  readonly messages: string[];
  readonly isValidationError = true;

  constructor(messages: string[]) {
    super(messages[0] || 'Validation failed');
    this.name = 'ApiValidationError';
    this.messages = messages;
    Object.setPrototypeOf(this, ApiValidationError.prototype);
  }
}

export function isApiValidationError(error: unknown): error is ApiValidationError {
  return error instanceof ApiValidationError;
}

export class SystemError extends Error {
  readonly requestId?: string;
  readonly referenceId?: string;
  readonly backendTraceId?: string;
  readonly statusCode?: number;

  constructor(
    message: string,
    opts?: { requestId?: string; referenceId?: string; backendTraceId?: string; statusCode?: number }
  ) {
    super(message);
    this.name = 'SystemError';
    this.requestId = opts?.requestId;
    this.referenceId = opts?.referenceId;
    this.backendTraceId = opts?.backendTraceId;
    this.statusCode = opts?.statusCode;
    Object.setPrototypeOf(this, SystemError.prototype);
  }
}

export function isSystemError(error: unknown): error is SystemError {
  return error instanceof SystemError;
}